import React from 'react'
import { Breadcrumbs } from '@/components/ui/breadcrumb'

import { TransactionDto } from '../../../../api/Transaction/Types/Transaction'
import { links } from '../../../../utils/featureToggles'
import TransactionDetailsAdjustmentWalletAndPaymentAgentPage from '../TransactionDetailsAdjustmentWalletAndPaymentAgent/TransactionDetailsAdjustmentWalletAndPaymentAgentPage'

interface Props {
  data: TransactionDto
  forceRefresh(): void
}

const TransactionDetailsIBCommissionsPage: React.FC<Props> = (props) => {
  return (
    <React.Fragment>
      <Breadcrumbs
        crumbs={[
          { title: 'Transaction - IB Commission', link: links.transactionIBCommissions.url },
        ]}
      />
      <TransactionDetailsAdjustmentWalletAndPaymentAgentPage {...props} />
    </React.Fragment>
  )
}

export default TransactionDetailsIBCommissionsPage
